import invariant from 'tiny-invariant';
import { z } from 'zod';
import { isStep, Step } from '~/components/Step';
import { BehaviorType } from '~/shared/domain/models';
import { download } from '~/utils/download';
import { generateFieldDefaultValue } from '~/utils/generateFieldDefaultValue';
import { redirect } from '~/utils/redirect';
import { generateFieldSchema } from '~/utils/schema';
import type { BehaviorSchema, StepSchema } from '~/shared/domain/models';

export type AnyRecord = Record<string, any>;

export const toStep = (step: StepSchema, index: number) => {
  invariant(isStep(step));

  const stepKey = `${step.componentType}-${step.title}`;
  return <Step data={step} key={stepKey} stepIndex={index + 1} />;
};

const toFields = (step: StepSchema) => {
  if (isStep(step)) {
    return step.children;
  }

  return [];
};

export const generateSchema = (step: StepSchema) => {
  invariant(isStep(step));

  const rawSchema = step.children.reduce((schema, field) => {
    schema[field.name] = generateFieldSchema(field);

    return schema;
  }, {} as AnyRecord);

  return z.object(rawSchema);
};

export const generateDefaultValues = (steps: Array<StepSchema>, persistedValues?: any) => {
  const fields = steps.flatMap(toFields);

  return fields.reduce((values, field) => {
    values[field.name] = generateFieldDefaultValue(field, persistedValues[field.name]);

    return values;
  }, {} as AnyRecord);
};

export const executeBehavior = (behavior?: BehaviorSchema) => {
  if (!behavior) {
    return;
  }

  switch (behavior.type) {
    case BehaviorType.download:
      download(behavior.url);
      break;

    case BehaviorType.redirect:
    default:
      redirect(behavior.url);
      break;
  }
};
